module.exports = __webpack_public_path__ + "static/media/fr.06aaed6d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/fr.svg
// module id = 2092
// module chunks = 0